var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"filter-wrapper"},_vm._l((_vm.tabList),function(value,index){return _c('div',{key:index,staticClass:"item",class:{active: index === _vm.activeIndex},on:{"click":function($event){return _vm.activeTab(index)}}},[_c('span',[_vm._v(_vm._s(value))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }